import { Component, OnInit } from '@angular/core';
import { QcloudConsoleService } from '../../qcloud-console.service';
import { Ticket } from 'projects/qcloud-models/console/ticket';
import { validateHorizontalPosition } from '@angular/cdk/overlay';

@Component({
  selector: 'lib-display-ticket',
  templateUrl: './display-ticket.component.html',
  styleUrls: ['./display-ticket.component.css']
})
export class DisplayTicketComponent implements OnInit {
  ticketCaption: string;
  ticket: Ticket;
  constructor(consoleService: QcloudConsoleService) {
    consoleService.ticket.subscribe((val: Ticket) => { this.ticket = val; this.ticketCaption = val?.caption });
  }

  ngOnInit(): void {

  }


  getCallingTime() {
    var dateTime = this.ticket.callingDate as unknown as string;
    if (!dateTime || !dateTime || dateTime === "0001-01-01T00:00:00+00:00") {
      return null;
    }
    const date = new Date(dateTime);
    if (isNaN(date.getTime())) {
      return null;
    }

    return date;
  }
}

